import { LibraryCache } from 'base/library_cache';
import { Button } from 'base/ui/button';
import { Icon } from 'base/ui/icon';
import { IconChevronRight } from 'base/ui/icons';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { getGlobalDesignStore } from '../design/design_store';
import { ElementInstance, Project } from '../model';
import { unrefSection } from '../model_helpers';
import { SelectionStore } from '../selection/store';
import { ProjectSession } from '../session/session';
import { SidebarNavigation } from '../sidebar/routes';
import { findOverridableImagesInElement } from '../styleguide/images';
import { SchemeRow } from './design_schemes';

export const SectionDesignControls = observer(function _SectionDesignControls({
  project,
  session,
  library,
  element,
  navigation,
  selection,
}: {
  project: Project;
  session: ProjectSession;
  library: LibraryCache;
  element: ElementInstance;
  navigation: SidebarNavigation;
  selection: SelectionStore;
}) {
  const concept = getGlobalDesignStore().design.linkedConcept;

  const designScheme =
    element.id != null ? concept.getDesignSchemeByElementId(element.id) : null;

  const [hasImages, setHasImages] = useState(false);

  const sel = selection.get();
  const sref = sel?.section;
  const section = sref != null ? unrefSection(sref, project) : null;

  useEffect(() => {
    if (section?.element.current == null) return;
    findOverridableImagesInElement(
      section.element.current.state,
      library,
      session.undo,
    ).then((images) => {
      setHasImages(images.length > 0);
    });
  }, [library, section?.element, session.undo]);

  if (designScheme == null) {
    return null;
  }

  const schemeNumber = concept.getDesignSchemeNumber(designScheme);

  return (
    <>
      <SchemeRow
        designScheme={designScheme}
        schemeNumber={schemeNumber}
        concept={concept}
        onClick={() => {
          navigation.goto({
            path: 'edit/schemes',
          });
        }}
        rightContent={
          <Icon icon={IconChevronRight} size={16} color="colorBlack" />
        }
      />
      {hasImages && (
        <Button
          label="Images"
          onClick={() => {
            navigation.goto({
              path: 'edit/images',
            });
          }}
        />
      )}
    </>
  );
});
